// extracted by mini-css-extract-plugin
export var notificationHost = "_ig-0";